import { api } from '../../lib/api';

export async function subscribeToNewsletter(email: string): Promise<void> {
  await api.post('/newsletter/subscribe', { email });
}
